<template>
  <div class="vh60 container">
    <div class="row mx-10 mt-10 b1 h5">{{ $t("recivers") }}</div>
    <div class="row font14 my-5" v-if="recivers">
      <div
        class="col-12 col-lg-6"
        align="right"
        dir="rtl"
        v-for="reciver in recivers"
        :key="reciver.id"
      >
        <div class="row light-blue-border mx-5 white-bcg">
          <div class="col-4">
            <v-icon>mdi-account-outline</v-icon>{{ reciver.name }}
          </div>
          <div class="col-8">
            <v-icon>mdi-phone</v-icon> {{ reciver.phone_number }}
          </div>
          <div class="col-12 scrollX p-6">
            <v-icon>mdi-map-marker</v-icon>{{ reciver.ostan }}
            {{ reciver.shahr }} {{ reciver.address }} {{ reciver.code }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      recivers: [
        {
          code: "",
        },
      ],
    };
  },
  mounted() {
    this.axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$session.get("token");
    this.axios.get("transferee").then((response) => {
      console.log(response.data[0]);
      this.recivers = response.data[0];
      this.recivers.code = this.$t('postCode') + response.data[0].code;
    });
  },
};
</script>
